module.exports = __webpack_public_path__ + "static/media/profile-picture-6.428fd30c.jpg";